import React, { useRef } from 'react';
import './ContainerBox.css';

const ContainerBox = ({
  title,
  children,
  isReady = false,
  readyLabel = 'Continue',
  onReadyClick,
  scrollToNext = true,
  isStale = false,
  onRefreshClick,
  refreshing = false,
  headerAction = null  // Custom action button in header (React node)
}) => {
  const containerRef = useRef(null);

  const handleReadyClick = () => {
    if (onReadyClick) {
      onReadyClick();
    }

    if (scrollToNext && containerRef.current) {
      // Wait for next section to render, then scroll
      setTimeout(() => {
        const nextElement = containerRef.current.nextElementSibling;
        if (nextElement) {
          nextElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  };

  return (
    <section ref={containerRef} className="container-box card">
      <div className="container-box__header">
        {title && <h2 className="container-box__title">{title}</h2>}
        <div className="container-box__header-actions">
          {headerAction}
          {isStale && onRefreshClick && (
            <button
              type='button'
              className="container-box__refresh"
              onClick={onRefreshClick}
              disabled={refreshing}
              aria-label="Refresh"
              title="Refresh to update with latest changes"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className={`bi bi-arrow-clockwise ${refreshing ? 'spinning' : ''}`}
                viewBox="0 0 16 16"
              >
                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
              </svg>
            </button>
          )}
        </div>
      </div>
      <div className="container-box__content">
        {children}
      </div>
      <div className="container-box__footer">
        {isReady && (
          <button
            type='button'
            className="container-box__ready"
            onClick={handleReadyClick}
            aria-label={readyLabel}
          >
            {readyLabel}
            <span className="container-box__ready-icon" aria-hidden>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-compact-down" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67"/>
              </svg>
            </span>
          </button>
        )}
      </div>
    </section>
  );
};

export default ContainerBox;

